<div class="edv-container w-100">

  <!-- Header -->
  <div class="edv-header d-flex justify-content-between align-items-center">
    <span class="edv-title">{{ metricDisplayName }}</span>
  </div>

  <!-- No Data View -->
  <app-no-data *ngIf="!data || data.length === 0"></app-no-data>

  <!-- Defect Rows -->
  <div class="defect-list" *ngIf="data && data.length > 0">
    <div *ngFor="let item of pagedData; let i = index" class="defect-item">

      <!-- Row summary (clickable) -->
      <div class="defect-row d-flex align-items-center gap-3" (click)="toggleRow(i)" (keydown)="toggleRow(i)">

        <!-- Status + Defect ID -->
        <div class="status-id-col">
          <span class="status-pill" [ngClass]="getStatusClass(item.status)">
            {{ getStatusLabel(item.status) }}
          </span>
          <div class="defect-id mt-1">{{ item.defect_id }}</div>
        </div>

        <!-- Spacer -->
        <div class="flex-grow-1"></div>

        <!-- Affected Test Cases count -->
        <div class="affected-col d-flex align-items-center gap-1">
          <img src="assets/images/virtusa-icons/document-icon.svg" alt="document" class="affected-icon">
          <span class="affected-text">{{ getAffectedCount(item) }} {{ affectedCountLabel }}</span>
        </div>

        <!-- Severity badge -->
        <div class="severity-col">
          <span class="severity-pill" [ngClass]="getSeverityClass(item.severity)">
            {{ capitalize(item.severity) }}
          </span>
        </div>

        <!-- Toggle button -->
        <button class="toggle-btn" (click)="toggleRow(i, $event)" [attr.aria-expanded]="isExpanded(i)"
          [attr.aria-label]="isExpanded(i) ? 'Collapse' : 'Expand'">
          <img *ngIf="!isExpanded(i)" src="assets/images/virtusa-icons/add-outline.svg" alt="expand"
            class="toggle-icon">
          <img *ngIf="isExpanded(i)" src="assets/images/virtusa-icons/remove-outline.svg" alt="collapse"
            class="toggle-icon">
        </button>

      </div>

      <!-- Expanded detail panel -->
      <div *ngIf="isExpanded(i)" class="defect-detail">

        <ng-container *ngIf="viewId === 'defectList'">
          <div class="detail-section">
            <span class="detail-label">Defect Description</span>
            <p class="detail-text">{{ item.defect_description }}</p>
          </div>

          <div *ngIf="getAffectedTestCases(item).length" class="detail-section mt-3">
            <span class="detail-label">Affected Test Cases</span>
            <ul class="tc-list">
              <li *ngFor="let tc of getAffectedTestCases(item)">{{ tc }}</li>
            </ul>
          </div>
        </ng-container>

      </div>

    </div>
  </div>

  <!-- Pagination -->
  <div class="edv-pagination" *ngIf="data && data.length > 0 && totalItems > pageSize">
    <nz-pagination
      [nzPageIndex]="pageIndex"
      [nzTotal]="totalItems"
      [nzPageSize]="pageSize"
      [nzShowSizeChanger]="false"
      (nzPageIndexChange)="onPageIndexChange($event)">
    </nz-pagination>
  </div>

</div>

